export const initialStateTotalizers = {
    sinteticoPorStatus: [
        {
            descricao: 'Registrado',
            quantidadeTotal: 0
        },
        {
            descricao: 'Recusado',
            quantidadeTotal: 0
        }
    ],
    sinteticoPorImagem: [
        {
            descricao: 'Com Imagem',
            quantidadeTotal: 0
        },
        {
            descricao: 'Sem Imagem',
            quantidadeTotal: 0
        }
    ],
    sinteticoPorDetran: [
        {
            descricao: 'Total de Detran(s)',
            quantidadeTotal: 0
        }
    ],
    sinteticoPorTipoServico: [
        {
            descricao: 'Inclusão Contrato',
            quantidadeTotal: 0
        },
        {
            descricao: 'Alter. Contrato',
            quantidadeTotal: 0
        },
        {
            descricao: 'Inclusão Aditivo',
            quantidadeTotal: 0
        },
        {
            descricao: 'Alter. Aditivo',
            quantidadeTotal: 0
        }
    ],
    sinteticoPorOrigem: [
        {
            descricao: 'Tela',
            quantidadeTotal: 0
        },
        {
            descricao: 'Api',
            quantidadeTotal: 0
        },
        {
            descricao: 'Lote',
            quantidadeTotal: 0
        }
    ]
}
